import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { HEADER_FOOTER_CONTROLER_URL } from "api/Service";

export const useHeaderFooter = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["headerFooter", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${HEADER_FOOTER_CONTROLER_URL}`
      );

      return response.data;
    },
    enabled: !!tenantVal,
  });
};
